<template>
    <main-content>
        <div class="clearfix">
            <router-link class="kt-nav__link m-2 btn btn-outline-primary float-right" to="/application/create">
                {{ $t('application.add_new_application') }}
            </router-link>
        </div>
        <manage-application v-if="$can('read', 'open-banking')"></manage-application>
        <common-application v-else></common-application>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import ManageApplication from './components/manage-access/application'
import CommonApplication from './components/common-access/application'

export default {
    components: {
        'main-content': mainContent,
        'manage-application': ManageApplication,
        'common-application': CommonApplication,
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
        }
    },
}
</script>

<style>
.switch-div {
    width: fit-content;
    padding: 8px 27px;
    background: #fff;
    box-shadow: 0 0 7px 0 #9c9c9c5e;
}

.switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #6aad27;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider {
    background-color: #2196F3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

.slider.round {
    border-radius: 50px;
}

.slider.round:before {
    border-radius: 50px;
}

.info-icon {
    cursor: pointer;
    color: #0f9af0;
    display: inline-block;
}
</style>